const NEXT_STORAGE_KEY = 'hps.playerNextPath';

/** Only allow in-app player paths after login (blocks open redirects). */
export function safePlayerNextPath(raw) {
  if (!raw || typeof raw !== 'string') return null;
  let path = raw.trim();
  try {
    path = decodeURIComponent(path);
  } catch {
    /* already decoded */
  }
  if (!path.startsWith('/')) path = `/${path}`;
  if (!path.startsWith('/player/')) return null;
  if (path.startsWith('//') || path.includes('://')) return null;
  if (path.includes('\\')) return null;
  return path;
}

export function playerOrganisedEventPath(eventId) {
  return `/player/events/tournaments/${eventId}`;
}

export function playerOrganisedEventSharePath(eventId) {
  return `/e/${eventId}`;
}

export function rememberPlayerNextPath(path) {
  const safe = safePlayerNextPath(path);
  if (!safe || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(NEXT_STORAGE_KEY, safe);
  } catch {
    /* ignore quota / private mode */
  }
}

export function peekPlayerNextPath() {
  try {
    return safePlayerNextPath(sessionStorage.getItem(NEXT_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function clearPlayerNextPath() {
  try {
    sessionStorage.removeItem(NEXT_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function readPlayerNextPath(queryNext) {
  return safePlayerNextPath(queryNext) || peekPlayerNextPath();
}
